import { render, staticRenderFns } from "./iframe_printer.vue?vue&type=template&id=60fcaae6&"
import script from "./iframe_printer.vue?vue&type=script&lang=js&"
export * from "./iframe_printer.vue?vue&type=script&lang=js&"
import style0 from "./iframe_printer.vue?vue&type=style&index=0&lang=less&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports